const ExclamationInCircle = ({ size = "30", color = "#22031F" }: { size?: string; color?: string }) => {
	return (
		<svg width={size} height={size} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M15 26.25C21.2132 26.25 26.25 21.2132 26.25 15C26.25 8.7868 21.2132 3.75 15 3.75C8.7868 3.75 3.75 8.7868 3.75 15C3.75 21.2132 8.7868 26.25 15 26.25Z"
				stroke={color}
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M15 9.375V15.9375"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15 21.5625C15.7767 21.5625 16.4062 20.9329 16.4062 20.1562C16.4062 19.3796 15.7767 18.75 15 18.75C14.2233 18.75 13.5938 19.3796 13.5938 20.1562C13.5938 20.9329 14.2233 21.5625 15 21.5625Z"
				fill={color}
			/>
		</svg>
	);
};
export default ExclamationInCircle;
